<template>
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head" >
                        <p class="modal-card-title">Add Credit Card</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
      <section class="modal-card-body">
        <b-field label="Display Name">
            <b-input placeholder="Display Name" v-model="customPayment.displayName"></b-input>
        </b-field>
        <b-field label="Name on Card">
            <b-input placeholder="Name" v-model="customPayment.cardholderName"></b-input>
        </b-field>

        <creditCardInput v-model="customPayment.cardNum" />

        <creditCardExpirationInput v-model="customPayment.expDate"/>
      </section>

      <footer class="modal-card-foot">
                        <b-button
                            label="Close"
                            @click="$emit('close')" />
                        <b-button
                            :disabled="disabled"
                            class="is-pulled-right"
                            label="Save"
                            type="is-primary"
                            @click="submit" />
      </footer>

    </div>
  </form>



</template>

<script>

import creditCardInput from './creditCardInput'
import creditCardExpirationInput from './creditCardExpirationInput'

    export default {
      name: 'AddCardModal',
      components: {
        creditCardInput,
        creditCardExpirationInput
      },
      data() {
        return {
          customPayment: {cardholderName: "",  cardNum: "", expDate: "", displayName: ""},
          default: {cardholderName: "",  cardNum: "", expDate: "", displayName: ""}
        }
      },
      methods: {
        submit() {
          var body = {
            "contactId": this.$globals.travellerProfile.id,
            "nameOnCard": this.customPayment.cardholderName,
            "brand": this.customPayment.cardNum.code,
            "number": this.customPayment.cardNum.num,
            "expirationMonth": this.customPayment.expDate.month.toString(),
            "expirationYear": this.customPayment.expDate.year.toString(),
            "displayName": this.customPayment.displayName
          }
          this.$app.huddleLabsServerCall('profile/payment-methods/create', body)
            .then(result => {
                // // console.log(result.data.id);
                this.$emit('update', result.data);
                this.$emit('input', result.data);
                this.customPayment = this.default;
                this.$emit('close');
              })
        }

      },
      computed: {
        disabled() {
          try {
            var name = this.customPayment.cardholderName.length > 0
            var cardNum = this.customPayment.cardNum.num
            var code = this.customPayment.cardNum.code
            var month = this.customPayment.expDate.month
            var year = this.customPayment.expDate.year
            var displayName = this.customPayment.displayName.length > 0
            return !(name && cardNum && code && month &&  year && displayName)
            // return false

          }
          catch {
            return true
          }
        },
      }
  }

</script>


<style scoped>

</style>
